export enum DEVICE_STATE {
  disconnected = 0,
  connecting = 1,
  connected = 2,
}


